/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { Routes } from '@angular/router';
import { environment } from '@env/environment';
import { OSKLoggedInGuard } from 'src/app/core/guards/logged-in/logged-in.guard';
import { OSKUserRoleGuard } from 'src/app/core/guards/user-role/user-role.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/home/home.component').then((c) => c.OSKHomeComponent)
  },
  {
    path: 'osk-ui',
    canActivate: environment.production ? [OSKLoggedInGuard, OSKUserRoleGuard] : [],
    data: {
      userRoles: ['v1.admin']
    },
    loadComponent: () =>
      import('@oskey/ui/showcase/osk-ui-showcase.component').then((c) => c.OSKUiShowcaseComponent)
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/authentication/auth.routes').then((r) => r.routes)
  },
  {
    path: 'admin',
    canActivate: [OSKLoggedInGuard],
    loadChildren: () => import('./features/portals/admin/admin.routes').then((r) => r.routes)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
